import { LitElement, html, css } from 'lit'

import '../../src/ui/views/select-wallet/select-wallet-header-dropdown.js'
import { go } from '../router/router-mixin.js'
import routes from '../router/routes.js'
import { headerLogoIcon } from '../assets/icons.js'
import { DaoRoles } from '../models/daos.values.js'
import { walletIcon, connectWalletIcon } from '../assets/icons.js'
import { profileIcon } from '../assets/svg/placeholder-svg/placeholder-svg.js'
import globalStyles from '../global-styles.js'
import { getSessionUser } from '../../src/utilities/session.js'
import { checkModalConnection } from '../Wallet-connect.js'
import AppEvents from '../../src/utilities/app-events.js'
import '../../src/ui/shared/tool-tip/auto-tool-tip.js'

class AppHeaderElement extends LitElement {
  static properties = {
    selectedDao: { type: Object },
    selectedAccount: { type: Object },
    accounts: { type: Array },
    opened: { type: Boolean, reflect: false },
    hideWalletSelect: { type: Boolean },
    viewHasToolbar: { type: Boolean },
    profilePic: { type: Object },
    user: { type: Object },
    connected: { type: Boolean },
    web3Mode: { type: Boolean },
  }
  constructor() {
    super()
    this.opened = false
    this.hideWalletSelect = null
    this.connected = false

    try {
      this.accounts = window.Globals.accounts
      this.selectedDao = window.Globals.selectedDao
      this.selectedAccount = window.Globals.selectedAccount
    } catch (error) {
      console.log(error)
    }
    window.addEventListener(
      'selected-account',
      this.handleWalletClick.bind(this)
    )
    this.viewHasToolbar = null
    this.user = getSessionUser()
  }

  async connectedCallback() {
    super.connectedCallback()

    window.addEventListener('wallet-connect', () => {
      this.connected = checkModalConnection()
    })

    this.web3Mode = await window.Globals.deviceCheck()

    window.Globals.onUpdate(
      (
        /** @type {CustomEvent} */ { detail: { selectedDao, selectedAccount } }
      ) => {
        this.selectedAccount = selectedAccount
        this.selectedDao = selectedDao
        this.accounts = window.Globals.accounts
        this.user = getSessionUser()
        this.connected = checkModalConnection()
      }
    )

    window.addEventListener(AppEvents.WALLET_SELECTOR_CLICKED, () => {
      this.handleWalletClick()
    })

    window.addEventListener(
      'wallet-connect',
      (/** @type {CustomEvent} */ { detail: { isConnected } }) => {
        this.connected = isConnected
      }
    )
    if (this.user) {
      this.updateProfilePic()
    }
  }

  updateProfilePic() {
    this.user = getSessionUser()
    // TODO: update this. Removed because temp-db is removed.
    // this.profilePic = getUserImage(this.user.email)
  }

  handleWalletClick() {
    this.opened = !this.opened
    window.Globals.checkWallets()
    window.dispatchEvent(
      new CustomEvent('open-wallet', {
        detail: { opened: this.opened },
        bubbles: true,
        composed: true,
      })
    )
  }

  handleLoggedInUser() {
    // TODO: update this. Removed because temp-db is removed.
    // this.profilePic = getUserImage(this.user.email)
  }

  initializeWeb3() {
    try {
      window.Globals.initW3()
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    return html`
      <div class="container">
        <div id="left-side">
          <div @click=${() => go(routes.DASHBOARD.path)} id="daoLogo">
            ${headerLogoIcon}
          </div>
        </div>

        <div class="wallet-section" id="right-side">
          <span
            ?hide=${this.hideWalletSelect}
            id="profile-settings"
            @click=${() => {
              go(routes.SETTINGS.path)
            }}
          >
            <div id="profile-container">${profileIcon}</div>
          </span>

          <div ?hide=${this.hideWalletSelect || !this.web3Mode}>
            ${this.connected
              ? html`
                  <span
                    id="wallet-selector"
                    class="${this.opened ? 'selectedIcon' : ''}"
                    @click=${this.handleWalletClick}
                    >${walletIcon}
                  </span>
                `
              : html`
                  <auto-tool-tip
                    flow="left"
                    tooltip="Connect your wallet to get started"
                  >
                    <button
                      class="connect-wallet-button"
                      @click=${this.initializeWeb3}
                    >
                      Connect ${connectWalletIcon}
                    </button>
                  </auto-tool-tip>
                `}
          </div>
        </div>
      </div>
      <select-wallet-header-dropdown
        .hasToolbar=${this.viewHasToolbar}
      ></select-wallet-header-dropdown>
    `
  }

  static styles = [
    globalStyles,
    css`
      @font-face {
        font-family: 'Lato';
        src: url('../assets/fonts/Lato-Regular.ttf') format('truetype');
        font-weight: 600;
        font-style: normal;
      }
      @font-face {
        font-family: 'Lato-Bold';
        src: url('../assets/fonts/Lato-Bold.ttf') format('truetype');
        font-weight: 600;
        font-style: normal;
      }
      :host {
        position: relative;
        width: 100%;
        background-color: #f7f7f7;
        border-bottom: 2px solid var(--light-grey);
        font-family: 'Lato', sans-serif;
      }

      div {
        display: flex;
        height: 100%;
        align-items: center;
        font-family: var(--primary-font-family);
        font-weight: 700;
      }
      .container {
        position: relative;
        z-index: 10;
        display: flex;
        width: 100%;
        align-items: space-between;
        background-color: #f7f7f7;
      }
      span {
        margin-left: 8px;
      }
      svg {
        height: 18px;
        width: auto;
        transition: fill 0.1s ease-in-out;
      }
      select-wallet-header-dropdown {
        position: absolute;
        right: 24px;
        z-index: 1;
      }
      #wallet-selector {
        display: flex;
        cursor: pointer;
      }
      #wallet-selector svg {
        height: 24px;
        width: 24px;
      }
      #wallet-selector.selectedIcon svg {
        fill: var(--kula-deep-green);
      }
      #profile-settings {
        cursor: pointer;
      }
      .connect-wallet-button {
        display: flex;
        padding: 8px;
        justify-content: center;
        align-items: center;
        gap: 4px;
        flex-shrink: 0;
        border-radius: var(--ButtonBorderRadiusXS, 4px);
        border: 2px solid var(--kula-deep-green);
        color: var(--kula-deep-green);
        font-family: 'Lato', sans-serif;
        font-size: var(--regular-font-size);
      }
      #left-side {
        position: absolute;
        left: 16px;
        display: flex;
        align-items: center;
        gap: 8px;
      }
      #right-side {
        position: absolute;
        right: 16px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 8px;
      }
      #profile-container {
        width: 18px;
        height: 18px;
        overflow: hidden;
        border: 2px solid var(--grey);
        border-radius: 50%;
        background-color: var(--white);
      }
      #profile-image {
        max-width: 100%;
        height: auto;
      }
      [hide] {
        display: none;
      }
    `,
  ]
}
customElements.define('app-header', AppHeaderElement)
export default AppHeaderElement
